import React, { useState } from 'react'
import { MySwal } from '../../../library/swal';
import axios from "../../../library/axios"
import Button from 'react-bootstrap/Button'
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const CreateChatComp = (props) => {
    // console.log(props?.score?.forums[0].id)

    const [chat, setChat] = useState('')

    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)

    const handleSubmitForum = () => {
        setLoading(true)
        setDisabled(true)
        if (props.score.forums.length == 0) {

            const requestBodyForum = {
                idSkors: props.score.id
            }

            axios({
                url: '/forum/create',
                method: 'POST',
                data: requestBodyForum,
                headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
            })
                .then(res => {
                    // console.log(res)
                    // return false
                    if (res.status === 200) {
                        handleSubmitChat(res?.data?.id)
                    }
                })
                .catch(err => {
                    setLoading(false)
                    setDisabled(false)
                    if (err !== "") {
                        console.log(err?.response)
                        MySwal.fire({
                            icon: 'error',
                            title: 'Oops, Error!',
                            text: `${err?.response?.data?.message}`
                        })
                    }
                })
        } else {
            handleSubmitChat(props?.score?.forums[0].id)
        }

    }

    const handleSubmitChat = (idForum) => {
        setLoading(true)
        setDisabled(true)

        const requestBody = {
            idForum: idForum,
            text: chat,
        }
        // console.log(requestBody)
        // return false
        axios({
            url: '/forum-chat/create-chat',
            method: 'POST',
            data: requestBody,
            headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
            .then(res => {
                // console.log(res)
                // return false
                if (res.status === 200) {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Berhasil menambahkan diskusi!'
                    })

                    setLoading(false)
                    setDisabled(false)

                    props.fetch()
                    props.close()
                }
            })
            .catch(err => {
                setLoading(false)
                setDisabled(false)
                if (err !== "") {
                    console.log(err?.response?.data?.message)
                    MySwal.fire({
                        icon: 'error',
                        title: 'Oops, Error!',
                        text: `${err?.response?.data?.message}`
                    })
                }
            })

    }

    return (
        <>
            <div className="mb-3 row">
                <label htmlFor="Chat" className="col-sm-12 col-form-label required">Komentar</label>
                <div className="col-12">
                    <textarea className='form-control' id='Chat' onChange={(e) => setChat(e.target.value)} value={chat} rows={3}></textarea>
                </div>
            </div>

            <div className="mt-5 row">
                <div className="col-12">
                    <Button variant="danger" size="sm" onClick={() => props.close()}>
                        Tutup
                    </Button>
                    &nbsp;
                    <Button disabled={disabled} variant="success" size="sm" onClick={() => handleSubmitForum()}>{loading === true ? 'Mohon Tunggu..' : 'Simpan'}</Button>
                </div>
            </div>
        </>
    )
}

export default CreateChatComp
